import { IssueCategoryCount } from '@src/state/document/types'

export interface ScorecardStateProps {
  showModal: boolean
  wordCount: number
  grammarIssuesCount: number
  navigateToExpertCheck?: () => void
  isPaidUser: boolean
}

export interface ScorecardDispatchProps {
  hideModal: (origin?: string) => void
  createOnExpertCheckClick: (navigate?: () => void) => void
  onCtaClick: () => void
}

export interface ScorecardMergedProps {
  onExpertCheckClick: () => void
}

export type ScorecardProps = ScorecardStateProps &
  ScorecardDispatchProps &
  ScorecardMergedProps

export interface IssuesProps {
  grammarIssuesCount: number
  issueCategoryCounts: IssueCategoryCount[]
}

export const IC_FLUENCY = 'Fluency'
export const IC_PUNCTUATION = 'Punctuation'
export const IC_GRAMMAR = 'Grammar'
export const IC_CLARITY = 'Clarity'
export const IC_CONCISION = 'Concision'
export const IC_SPELLING = 'Spelling'
export const IC_TYPOS = 'Typos'
export const IC_STYLE = 'Style'
export const IC_OTHER = 'Other'

export type IssueCategory =
  | typeof IC_FLUENCY
  | typeof IC_PUNCTUATION
  | typeof IC_GRAMMAR
  | typeof IC_CLARITY
  | typeof IC_CONCISION
  | typeof IC_SPELLING
  | typeof IC_TYPOS
  | typeof IC_STYLE
  | typeof IC_OTHER

export interface PlagiarismStateProps {
  paidMember: boolean
  similarity: number | undefined
  hasCheckedPlagiarism: boolean
  plagiarismFound: boolean
  navigateToPlagiarism?: () => void
  isDemo: boolean
}

export interface PlagiarismDispatchProps {
  hideModal: (origin?: string) => void
  handleFreeTrialStart: () => void
  checkPlagiarism: () => void
  onUserClick: () => void
}

export interface PlagiarismMessageProps {
  plagiarismFound: boolean
  handleUpgrade: () => void
}

export interface PaidPlagiarismMessageProps {
  hasCheckedPlagiarism: boolean
  similarity: number | undefined
  handlePlagiarismCheck: () => void
}



// WEBPACK FOOTER //
// ./src/components/Modals/PaperScorecardModal/types.ts